<template>
  <div class="home">
      <header>
        <h1>Devices</h1>
        <span>Got a new device?
            <router-link :to='{name: "devices.activate"}'> Activate now!</router-link>
        </span>
      </header>
    <div v-if="!length" class="no-device">
        <i class="fa fa-tablet-alt head"></i>
        <h2>No device found</h2>
        <p>
            Lorem ipsum add device.
            Lorem ipsum add device.
            Lorem ipsum add device.
            Lorem ipsum add device.
        </p>
        <router-link :to="{name: 'devices.activate'}" class="btn btn-primary">
            Add new device
        </router-link>
    </div>
    <div v-else class="devices">
        <Device class="device" />
        <Device class="device" />
        <Device class="device" />
        <Device class="device" />
    </div>
  </div>
</template>

<script>
import Device from '@/components/Device.vue'

export default {
    name: 'list-devices',
    data() {
        return {
            length: true
        }
    },
    components: {
        Device
    }
};
</script>


<style lang="scss" scoped>
</style>
